import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import { getItemUrl } from "sprout-lib";
import { media } from "sprout-ui-theme";
import styled from "styled-components";
import { usePrevious } from "sprout-hooks";
import { useHistory } from "react-router-dom";
import ExtensionCallOut from "@sprout/client-components/dist/ExtensionCallOut";
import { OnboardMessage } from "sprout-ui-dom";
import { useIsTopicPageOnboard, useIsMyTasksPageOnboard, useIsReadLaterPageOnboard } from "@sprout/hooks/dist/onboard";
import TopicPageHeader from "../TopicPageHeader";
import { useTopicPage } from "../TopicPageContext";
import TopicPageViewsTopicList from "./TopicPage_Views_Topic_List";
import TopicPageViewsTopicTopicMembers from "./TopicPage_Views_Topic_TopicMembers";
import BaseTopicPageViewsTopicTopicButtons from "./TopicPage_Views_Topic_TopicButtons";
const TopicPageViewsTopicTopicButtons = styled(BaseTopicPageViewsTopicTopicButtons)`
  ${media.up("medium", "pointer")} {
    display: none;
  }

  > * {
    margin-top: 8px;
  }
`;
const TopicPageViewsTopicMain = (props)=>{
    const { topic  } = props;
    const { rootTopicOrSelf , id  } = topic;
    const isRootTopic = !!topic.isRootTopic;
    const { members , memberCount: memberCountProp , owner , special ,  } = rootTopicOrSelf || {};
    const memberCount = memberCountProp || 0;
    const topicMembers = (members === null || members === void 0 ? void 0 : members.nodes) || [];
    const rootURL = getItemUrl(rootTopicOrSelf, owner);
    const isSpecial = !!special;
    const { isPartOfTopic  } = useTopicPage();
    const history = useHistory();
    const previousId = usePrevious(id);
    const previousURL = usePrevious(getItemUrl(topic, owner));
    const currentURL = getItemUrl(topic, owner);
    useEffect(()=>{
        if (previousId === id && previousURL !== currentURL) history.replace(currentURL);
    }, [
        currentURL,
        history,
        id,
        previousId,
        previousURL
    ]);
    const [isTopicPageOnboard] = useIsTopicPageOnboard();
    const [isMyTasksPageOnboard] = useIsMyTasksPageOnboard();
    const [isReadLaterPageOnboard] = useIsReadLaterPageOnboard();
    const showTopicMembers = isRootTopic && !isSpecial && (!isPartOfTopic || memberCount > 1);
    const isTopicEmpty = topic.posts.totalCount === 0 && topic.sections.totalCount === 0;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageHeader, {
                topic: topic,
                buttons: /*#__PURE__*/ _jsx(TopicPageViewsTopicTopicButtons, {
                    topic: topic
                })
            }),
            showTopicMembers && /*#__PURE__*/ _jsx(TopicPageViewsTopicTopicMembers, {
                topicMembers: topicMembers,
                memberCount: memberCount,
                rootURL: rootURL
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsTopicList, {
                topic: topic
            }),
            isPartOfTopic && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    !special && !isTopicEmpty && isTopicPageOnboard && /*#__PURE__*/ _jsx(ExtensionCallOut, {}),
                    special === "MY_TASKS" && !isTopicEmpty && isMyTasksPageOnboard && /*#__PURE__*/ _jsx(ExtensionCallOut, {}),
                    special === "INBOX" && !isTopicEmpty && isReadLaterPageOnboard && /*#__PURE__*/ _jsx(ExtensionCallOut, {})
                ]
            }),
            !isTopicPageOnboard && isPartOfTopic && !special && isTopicEmpty && /*#__PURE__*/ _jsxs(OnboardMessage, {
                rotate: true,
                title: "Organize it",
                position: "fixed",
                children: [
                    /*#__PURE__*/ _jsx("em", {
                        children: "Save your work to Leaves"
                    }),
                    ". Organize Leaves into Branches.",
                    /*#__PURE__*/ _jsx("em", {
                        children: " Tap \u201CLeaf\u201D to add to your Tree"
                    }),
                    "."
                ]
            }),
            !isMyTasksPageOnboard && isPartOfTopic && special === "MY_TASKS" && isTopicEmpty && /*#__PURE__*/ _jsxs(OnboardMessage, {
                rotate: true,
                title: "Personal workspace",
                position: "fixed",
                children: [
                    "Add a few personal tasks that you would like to accomplish.",
                    /*#__PURE__*/ _jsx("em", {
                        children: " Tap \u201CLeaf\u201D to add to continue"
                    }),
                    "."
                ]
            }),
            !isReadLaterPageOnboard && isPartOfTopic && special === "INBOX" && isTopicEmpty && /*#__PURE__*/ _jsxs(OnboardMessage, {
                rotate: true,
                title: "Get it off your mind",
                position: "fixed",
                children: [
                    /*#__PURE__*/ _jsx("em", {
                        children: "Save articles to read later"
                    }),
                    ". Tap \u201CLeaf\u201D to paste a link from your clipboard or install our browser extension to save links faster."
                ]
            })
        ]
    });
};
export default TopicPageViewsTopicMain;
